import createVueComponent from '../createVueComponent';

const MoveLeft = createVueComponent('MoveLeftIcon', [
  ['path', { d: 'M6 8L2 12L6 16', key: 'kyvwex' }],
  ['path', { d: 'M2 12H22', key: '1m8cig' }],
]);

export default MoveLeft;
